import { toast } from "react-toastify";

const checkPermission = (user, access) => {
  if (user.userEmail === "Admin@gmail.com") {
    return true;
  }
  if (user.permissions.includes(access)) {
    return true;
  }
  return false;
};

async function copyToClipboard(text) {
  try {
    if (window?.electronAPI?.isElectron) {
      // ✅ Electron: use electron API
      window.electronAPI.copyToClipboard(text);
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      // ✅ Browser: use modern API
      await navigator.clipboard.writeText(text);
    } else {
      // ⚠️ Fallback: older browsers
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed"; // avoid scrolling to bottom
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }
    toast.success("Message copied to clipboard!");
  } catch (err) {
    console.error("Failed to copy: ", err);
    toast.error("Failed to copy link!");
  }
}

// ✅ Export both
export { checkPermission, copyToClipboard };
